import React, {Component} from 'react';
import {ControlLabel, FormControl, FormGroup} from "react-bootstrap";
import FieldGroup from "../FieldGroup";
import PropTypes from "prop-types";

class ValueSelect extends Component {
    selectedFromValueSelect(e) {
        let value = this.props.propertyDefinition.possibleValues[e.target.value];
        this.props.onChange(value.id)
    }

    inputProps() {
        switch(this.props.propertyDefinition.type) {
            case 'AppBundle\\Form\\Type\\CustomTextareaType':
                return {componentClass: 'textarea'};
            case 'AppBundle\\Form\\Type\\MoneyType':
                return {type: 'number'};
            case 'AppBundle\\Form\\Type\\CustomNumberType':
                return {type: 'number'};
            default:
                return {type: 'text'}
        }
    }

    renderInput(label, onChange) {
        switch (this.props.propertyDefinition.type) {
            case 'AppBundle\\Form\\Type\\ValueSelectType':
                return <FormGroup controlId="value-select-control">
                        {this.props.label && <ControlLabel>{this.props.label}</ControlLabel>}
                        <FormControl componentClass="select" placeholder="select" value={this.props.value}
                                        onChange={e => this.selectedFromValueSelect(e)}>
                        {this.props.value.trim() === "" && <option key="" value=""></option>}
                        {Object.keys(this.props.propertyDefinition.possibleValues).map(id =>
                            <option key={id} value={id}>
                                {this.props.propertyDefinition.possibleValues[id].description} - {this.props.propertyDefinition.possibleValues[id].value}
                            </option>
                        )}
                    </FormControl>
                </FormGroup>;

            default:
                return <FieldGroup
                    id={this.props.label}
                    type="text"
                    label={this.props.label}
                    value={this.props.value}
                    onChange={e => this.props.onChange(e.target.value)}
                    placeholder="..."
                    {...this.inputProps()}
                />;
        }
    }

    render() {
        return (
            this.props.propertyDefinition ? <div>
                {this.renderInput()}
            </div> : null
        );
    }
}

ValueSelect.propTypes = {
    propertyDefinition: PropTypes.object,
    value: PropTypes.string,
};

export default ValueSelect;



// WEBPACK FOOTER //
// ./src/components/reusables/ValueSelect.js